import React from 'react';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Button, Col, Row } from 'antd';
import { message } from 'components/common';
import { SecondaryButton } from 'components/common/styles';
import { COMMON_ERR_MSG_DEFAULT_DISPLAY_DURATION, SMART_PO_RECV_LIST_REQ_SIZE } from 'constants/config';
import { PatternCodeType } from 'components/Admin/PatternCode';
import {
  GreenColor,
  SmartBackButton,
  SmartFormLabel,
  SmartScanner,
  SmartSpace,
  //SmartSpin,
  playSound,
} from 'components/Sales/Smart/SmartComponent';
import { fetchPoList } from 'services/purchaseOrder';
import PoListView from './PoListView';
import { PoRecvActionType as PRAction, PoRecvStep } from './context';
import {
  extractPatternCodeList,
  getMatchedPatternCode,
  isAnyPatternMatched,
  isPatternCodeEnabled,
} from '.';

type Props = ReduxStateProps & {
  gotoAnchor?: Function;
  onSelectPo: Function;
};

const PHeight1 = 10;

const ScanPo = (props: Props) => {
  const { useRef, useState } = React;
  // eslint-disable-next-line
  const [autoFocus, setAutoFocus] = useState(1)
  const [contentWrapperHeight, setContentWrapperHeight] = useState(0);
  const [contentWrapperStyle, setContentWrapperStyle] = useState<StringKAnyVPair>({});
  const [inited, setInited] = useState(false);
  const [isFetching, setIsFetching] = useState(false);
  const [poCount, setPoCount] = useState<number>();
  const [searchPo, setSearchPo] = useState('');
  const history = useHistory();
  const { t } = useTranslation();
  const gridDataPolicy = useRef<number>(0); // 0 is replace, 1 is append
  const gridPageIndex = useRef<number>(0);
  const gridPageSize = useRef<number>(SMART_PO_RECV_LIST_REQ_SIZE);
  const inputCtn = useRef<any>(null);
  const contentWrapper = useRef<any>(null);
  const footer = useRef<any>(null);

  const adjustContentLayout = () => {
    let [h1, h2, h3] = [0, 0, 0];
    let t1 = 0;

    if (inputCtn.current) {
      const ctn = inputCtn.current;

      h1 = ctn.offsetHeight;
      t1 = ctn.offsetTop;
    }

    if (footer.current) {
      h3 = footer.current.offsetHeight;
    }

    if (contentWrapper.current) {
      const wh = window.innerHeight;

      h2 = wh - t1 - h1 - h3 - PHeight1 * 3;
    }
    //console.log(h1, h2, h3, t1);
    setContentWrapperHeight(h2);
    setContentWrapperStyle({height: h2, marginBottom: 0});
  };

  // eslint-disable-next-line
  const checkPatternCode = () => {
    const { dispatch, state } = props;

    if (isPatternCodeEnabled(state)) {
      if (state.nextPatternCode) {
        handleScannerChange(state.nextPatternCode);
        dispatch({ type: PRAction.SetNextPatternCode, params: '' });
      }
    }
  };

  const footerButtons = () => {
    return (
      <Row justify="space-between">
        <Col span={12} style={{paddingRight: 5}}>
          <SecondaryButton
            onClick={() => handleScannerChange('')}
            size="large"
            style={{width: '100%'}}
            type="primary"
          >
            Browse PO(s)
          </SecondaryButton>
        </Col>
        <Col span={12} style={{paddingLeft: 5}}>
          <Button
            //onClick={() => history.goBack()}
            onClick={onPageBack}
            size="large"
            style={{width: '100%'}}
            type="primary"
          >
            {t("smart.common.goBack")}
          </Button>
        </Col>
      </Row>
    );
  };

  const getNextPagePoList = async () => {
    gridDataPolicy.current = 1;
    gridPageIndex.current = gridPageIndex.current + 1;

    return await getPoList(searchPo);
  };

  const getPoList = async (
    poNumberSearchValue: string,
    typeName = 'poNumber',
  ) => {
    const { dispatch, state } = props;

    setIsFetching(true);
    dispatch({ type: PRAction.SetLockScreen, params: true });
    try {
      const polist = await fetchPoList({
        warehouseCode: state.selectedWarehouse.warehouseCode,
        filterFieldName: typeName,
        filterKey: poNumberSearchValue || '',
        //poStatus: [1, 2].join(','),
        //poStatusNum: -1,
        sortBy: 'fulfillmentPoNum desc',
        skip: gridPageIndex.current * gridPageSize.current,
        limit: gridPageSize.current,
      });

      if (typeof polist.count === 'number') setPoCount(polist.count);

      if (polist.data.length === 0) {
        playSound('error');

        if (poNumberSearchValue !== '') message.warning({ content: `No PO[${poNumberSearchValue}] matched`, duration: COMMON_ERR_MSG_DEFAULT_DISPLAY_DURATION });
        if (isPatternCodeEnabled(state) && state.recvItems.length > 0 && props.gotoAnchor) {
          dispatch({ type: PRAction.SetMatchedPatternList, params: [] });
          props.gotoAnchor(PoRecvStep.RecvPo);
        }
        return;
      }

      const pos = polist.data.map((item) => {
        return { ...item, receivingQty: 0 };
      }); 
      dispatch({
        type: PRAction.SetPoList,
        params: gridDataPolicy.current === 0 ? pos : [ ...state.poList, ...pos ],
      });
      console.log('pl', polist.data);
      if (polist.data.length > 1) {
        const found = !!poNumberSearchValue && pos.find(e => e.poNumber === poNumberSearchValue);

        //setSelectPoDialogVisible(true);
        setTimeout(adjustContentLayout, 0);

        if (found) props.onSelectPo(found);
      } else {
        //checkWarehouse(polist.data[0]);
        props.onSelectPo(polist.data[0]);
      }

      return polist.data;
    } catch (err) {
      console.log(err);
    } finally {
      setIsFetching(false);
      dispatch({ type: PRAction.SetLockScreen, params: false });
    }
  };
  // const getPoListBySku =

  const handleScannerChange = (val: string) => {
    const { dispatch, state } = props;
    const sk = val.trim();
    const codeList: StringKAnyVPair[] = [];
    let po = sk;
    //console.log('val', val);
    if (sk !== '')  playSound('bell');

    if (po && isPatternCodeEnabled(state)) {
      const pl = extractPatternCodeList(state, sk);
      const patternMatched = isAnyPatternMatched(pl || []);

      //console.log('pl', pl);
      (pl || []).forEach(e => codeList.push(e));

      if (pl && patternMatched) po = getMatchedPatternCode(pl, PatternCodeType.PO);

      if (!po) {
        message.warning({ content: 'No PO found', duration: COMMON_ERR_MSG_DEFAULT_DISPLAY_DURATION });
        return;
      }
    }

    // maybe need to store the sk
    dispatch({ type: PRAction.SetMatchedPatternList, params: codeList });
    gridDataPolicy.current = 0;
    gridPageIndex.current = 0;
    setSearchPo(po);
    getPoList(po);
  };

  const onPageBack = () => {
    //history.goBack();
    if (props.state.enableMultiPurposeCode) {
      history.push('/smart/poreceive');
    } else {
      history.push('/smart');
    }
  };

  React.useEffect(() => {
    if (!inited) {
      checkPatternCode();
      setTimeout(adjustContentLayout, 0);
      setInited(true);
    }
  }, [checkPatternCode, inited]);

  return (<>
    {/*<SmartSpin loading={isFetching} />*/}
    <SmartSpace ref={inputCtn} style={{marginBottom: PHeight1}}>
      <SmartFormLabel
        style={{ color: GreenColor, fontWeight: 600, fontSize: 18 }}
      >
        {isPatternCodeEnabled(props.state) ? 'Input code to start' : t('smart.poreceive.scanToStart')}
      </SmartFormLabel>
      <SmartScanner
        disabled={isFetching}
        isAutoFocus={autoFocus}
        placeholder={isPatternCodeEnabled(props.state) ? 'Input code here' : 'Input PO# here'}
        style={{ marginTop: 10 }}
        onChangeValue={handleScannerChange}
      />
    </SmartSpace>
    <SmartSpace ref={footer} style={{marginBottom: PHeight1}}>
      <SmartBackButton
        children={footerButtons()}
        onHeightChange={() => setTimeout(adjustContentLayout, 0)}
      />
    </SmartSpace>
    {props.state.poList.length > 0 && (
      <SmartSpace
        ref={contentWrapper}
        style={contentWrapperStyle}
      >
        <PoListView
          getPoList={getNextPagePoList}
          height={contentWrapperHeight}
          onSelectPo={props.onSelectPo}
          poList={props.state.poList}
          total={poCount}
        />
      </SmartSpace>
    )}
  </>);
};

export default ScanPo;
